import { Injectable } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class ViewportService {
	isMobile$: Observable<boolean>;

	constructor(private breakpointObserver: BreakpointObserver) {
		this.isMobile$ = this.breakpointObserver.observe(['(max-width: 767px)'])
			.pipe(map(result => result.matches));
	}

	calculateMainContentHeight(): number {
		const screenHeight = window.innerHeight;

		if (screenHeight > 0) {
			const navBar = document.getElementById('maincontent_navbar');
			const searchBar = document.getElementById('maincontent_searchbar');
			const usOfficialBanner = document.getElementById('us_official_header_banner');
			const brandBanner = document.getElementById('brand_header_banner');
			const pageFooter = document.getElementById('kv_footer');

			const navBarHeight = navBar ? navBar.offsetHeight : 0;
			const usOfficialBannerH = usOfficialBanner ? usOfficialBanner.offsetHeight : 0;
			const brandBannerH = brandBanner ? brandBanner.offsetHeight : 0;
			const navBarH = navBarHeight + usOfficialBannerH + brandBannerH;
			
			const searchBarH = searchBar ? searchBar.offsetHeight : 0;
			
			const pageFooterH = pageFooter ? pageFooter.offsetHeight : 0;
			
			const mainContentHeight = screenHeight - (navBarH + searchBarH + pageFooterH);
			
			return mainContentHeight;
		}
		
		return 0;
	}
}
